<template>

    <div class="search-result">
        <div class="row">
            <div class="col-sm-2">
                <span class="item">Bail Agent:</span>
            </div>
            <div class="col-sm-4">
                <span>{{ getFormattedName() }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-2">
                <span class="item">License #</span>
            </div>
            <div class="col-sm-4">
                <span>{{ bailRecord.bailAgentLicNbr }}</span>
            </div>
        </div>
        <div class="row pad-bottom-10">
            <div class="col-sm-2">
                <span class="item">Address:</span>
            </div>
            <div class="col-sm-4">
                <span>{{ bailRecord.agentAddress }}</span>
            </div>
        </div>
        <div class="row pad-bottom-10">
            <div class="col-sm-2">
                <span class="item">Defendant:</span>
            </div>
            <div class="col-sm-10">
                <span>{{ bailRecord.defendant }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-2">
                <span class="item">Bond Number:</span>
            </div>
            <div class="col-sm-4">
                <span>{{ bailRecord.bondNumber }}</span>
            </div>
            <div class="col-sm-2">
                <span class="item">Case Number:</span>
            </div>
            <div class="col-sm-4">
                <span>{{ bailRecord.caseNumber }}</span>
            </div>
        </div>
        <div class="row pad-bottom-0">
            <div class="col-sm-2">
                <span class="item">Posted Date:</span>
            </div>
            <div class="col-sm-4">
                <span>{{ postedDate }}</span>
            </div>
            <div class="col-sm-2">
                <span class="item">Court:</span>
            </div>
            <div class="col-sm-4">
                <span>{{ bailRecord.court }}</span>
            </div>
        </div>
        <div class="row pad-bottom-0">
            <div class="col-sm-2">
                <span class="item">Bond Type:</span>
            </div>
            <div class="col-sm-4">
                <span>{{ bailRecord.bondType }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-2">
                <span class="item">Bond Amount:</span>
            </div>
            <div class="col-sm-4">
                <span>{{ bondAmount }}</span>
            </div>
        </div>
        <hr />
    </div>

</template>
<script>

    import moment from 'moment';

    export default {
        name: "SearchResult",
        props: ["bailRecord"],
        data() {
            return {
                nodes: [],
            }
        },
        computed: {
            bondAmount() {
                return '$' + this.bailRecord.bondAmount.toLocaleString('en');
            },
            postedDate() {
                return moment(this.bailRecord.postedDate).format("YYYY-MM-DD");
            }
        },
        methods: {

            getFormattedName() {

                let record = this.bailRecord;

                let name = '';

                if (record.nameFirst)
                    name = record.nameFirst;

                if (record.nameMid)
                    name = name.concat(' ', record.nameMid);

                if (record.nameLast)
                    name = name.concat(' ', record.nameLast);

                if (record.nameSfxKy)
                    name = name.concat(' ', record.nameSfxKy);

                return name.trim();
            },
        }
    }
</script>
